import { MouseEventHandler, PropsWithChildren } from "react";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";
import { GenericSolidButton } from './Button.styled';

interface ISolidButton{
    color?: string;
    width?: number;
    onClick?: MouseEventHandler;
    disabled?: boolean;
}

export const FilledButton = ({color, width, onClick, disabled, children}: PropsWithChildren<ISolidButton>)=>{

    return(
        <GenericSolidButton  color={color} width={width} disabled={disabled} onClick={onClick}>
            {children}
        </GenericSolidButton>
    )
}

FilledButton.displayName = 'FilledButton';